module.exports = __webpack_public_path__ + "static/media/HCMM975.94944827.jpg";